var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-info-circle",
    "data-name": "Icon awesome-info-circle",
    d: "M10.563.563a10,10,0,1,0,10,10A10,10,0,0,0,10.563.563Zm0,4.435A1.694,1.694,0,1,1,8.869,6.692,1.694,1.694,0,0,1,10.563,5ZM12.821,15.24a.484.484,0,0,1-.484.484H8.788A.484.484,0,0,1,8.3,15.24v-.968a.484.484,0,0,1,.484-.484h.484V11.208H8.788a.484.484,0,0,1-.484-.484V9.756a.484.484,0,0,1,.484-.484h2.581a.484.484,0,0,1,.484.484v4.032h.484a.484.484,0,0,1,.484.484Z",
    transform: "translate(-0.563 -0.563)",
    fill: "#ff3939"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.87864b36c56fcdb07e82f1f482603a49.svg";
export { ForwardRef as ReactComponent };